import script from "./LocationFormServiceStations.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationFormServiceStations.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__